export const WARNING_TYPES = {
  NO_FACE: 'NO_FACE',
  MULTIPLE_FACES: 'MULTIPLE_FACES',
  FULLSCREEN_EXIT: 'FULLSCREEN_EXIT',
  TAB_SWITCH: 'TAB_SWITCH',
  COPY_PASTE_ATTEMPT: 'COPY_PASTE_ATTEMPT',
  MULTIPLE_SCREENS: 'MULTIPLE_SCREENS'
};

export const STATUS_TYPES = {
  INITIALIZING: 'INITIALIZING',
  MODEL_LOADING: 'MODEL_LOADING',
  MODEL_LOADED: 'MODEL_LOADED',
  WEBCAM_REQUESTING: 'WEBCAM_REQUESTING',
  WEBCAM_READY: 'WEBCAM_READY',
  STARTING: 'STARTING',
  STARTED: 'STARTED',
  STOPPING: 'STOPPING',
  STOPPED: 'STOPPED',
  ERROR: 'ERROR',
  DESTROYED: 'DESTROYED'
};

export const DEFAULT_TFJS_PATH = 'https://cdn.jsdelivr.net/npm/@tensorflow/tfjs';
export const DEFAULT_BLAZEFACE_PATH = 'https://cdn.jsdelivr.net/npm/@tensorflow-models/blazeface';

export const DEFAULT_THROTTLE_DURATIONS = {
  [WARNING_TYPES.NO_FACE]: 3000,
  [WARNING_TYPES.MULTIPLE_FACES]: 3000,
  [WARNING_TYPES.FULLSCREEN_EXIT]: 1000,
  [WARNING_TYPES.TAB_SWITCH]: 1000,
  [WARNING_TYPES.COPY_PASTE_ATTEMPT]: 1000,
  [WARNING_TYPES.MULTIPLE_SCREENS]: 10000,
};